import ImageLayer from "ol/layer/Image";
import TileLayer from "ol/layer/Tile";
import { ImageWMS, XYZ } from "ol/source";
import { GEOSERVER } from "config/URL/URL";
import { Map, Overlay } from "ol";

export const doubleMap = ({ map, layers, onClickMapHandle, borderLayer, sidoBorderLayer, setOverlayStates }) => {
    const mountEvent = () => {    
        map.removeLayer(layers[1]);

        const vworldLayer = new TileLayer({
            title: 'VWorld white Map',
            visible: true,
            type: 'white',
            source: new XYZ({
                url: 'https://xdworld.vworld.kr/2d/white/service/{z}/{x}/{y}.png'
            })
        });

        const sidoWmsLayer = new ImageLayer({
            properties: {
                layerName: 'sido_wms'
            },
            source: new ImageWMS({
                url: GEOSERVER + '/geoserver1/wms',
                params: { 'LAYERS': 'gis_solution:ts_admin_sido' },
                ratio: 1,
                serverType: 'geoserver',
            }),
            opacity: 0.8,
            zIndex: 99
        })

        const sggWmsLayer = new ImageLayer({
            properties: {
                layerName: 'sgg_wms'
            },
            source: new ImageWMS({
                url: GEOSERVER + '/geoserver1/wms',
                params: { 'LAYERS': 'gis_solution:ts_admin_sgg' },
                ratio: 1,
                serverType: 'geoserver',
            }),
            opacity: 0.8,
            zIndex: 98
        })

        const overlay = new Overlay({
            element: document.getElementById('popup_1'),
            autoPan: true,
            autoPanAnimation: {
            duration: 250,
            },
        });

        setOverlayStates((prev) => {
            const updatedArray = [...prev];
            updatedArray[1] = overlay;
            return updatedArray;
        });
        
        const subMap = new Map({
            layers: [vworldLayer, sidoWmsLayer, sggWmsLayer, layers[1], borderLayer, sidoBorderLayer],
            target: "sub_map_area",
            view: map.getView(),
            overlays: [overlay]
        });

        subMap.on('click', onClickMapHandle);
    }


    const dismountEvent = () => {
        map.addLayer(layers[1]);

        const container = document.getElementById("sub_map_area");

        if(container) {
            while (container.firstChild) {
                container.removeChild(container.firstChild);
            }

        }
        
    }

    return { mount: mountEvent, dismount: dismountEvent };
}